import React from "react";
import { Input, NoDataFound, Spinner, Tabs } from "@public/ui-toolkit";
import CanCan from "../CanCan";
import { Col, Row, Badge } from "antd";
import { useState } from "react";

const RoomType = [
  {
    id: 0,
    name: "Private"
  },
  {
    id: 1,
    name: "Group"
  }
]
const ChatSidebar = ({
  isAllocator,
  getMessages,
  activeRoom,
  updateArchive,
  archiveRooms,
  loading,
  archiveMode,
  setArchiveMode,
  rooms,
  tabs,
  onClickChatTab,
  Permissions,
  type = 0,
  messageResult = 0,
}) => {
  console.log("messageResult", rooms);
  const [companyType, setCompanyType] = useState(type)
  return (
    <Row className="chat-sidebar">

      <Col span={24}>
        <ul className="nav nav-tabs hf-nav-tabs2 mt-2" id="myTab" role="tablist">
          {isAllocator && (
            <>
              <li className="nav-item position-relative" role="presentation">
                <Tabs
                  tabType={companyType === 0 ? "primary" : "allocator"}
                  controls="allocator"
                  ariaSelected="true"
                  target="#allocator"
                  tabName="Allocators"
                  id="allocator-tab"
                  onClick={() => {                    
                    onClickChatTab(0);                    
                    setCompanyType(0);
                  }}
                />
              </li>

              <li className="nav-item position-relative" role="presentation">
                <Tabs
                  tabType={companyType === 1 ? "primary" : "hedgefund"}
                  ariaSelected="false"
                  target="#hedgefund"
                  tabName="Hedge Fund"
                  id="hedgefund-tab"
                  onClick={() => {                    
                    onClickChatTab(1);                    
                    setCompanyType(1)
                  }}
                />
              </li>
            </>
          )}
          {!isAllocator && (
            <li className="nav-item position-relative" role="presentation">
              <Tabs
                tabType={companyType === 1 ? "primary" : "allocator"}
                ariaSelected="false"
                target="#hedgefund"
                tabName="Allocators"
                id="allocator-tab"
                onClick={() => {                  
                  onClickChatTab(1);                  
                  setCompanyType(1)
                }}
              />
            </li>

          )}
          <li className="nav-item position-relative" role="presentation">
            <Tabs
              tabType={companyType === 2 ? "primary" : "fcn"}
              controls="allocator"
              ariaSelected="true"
              target="#fcn"
              tabName="FCN"
              id="allocator-tab"
              onClick={() => {                
                onClickChatTab(2);                
                setCompanyType(2);
              }}
            />
          </li>
        </ul>
      </Col>

      <Col span={24} className=" px-3 py-2">
        <Input
          type="text"
          id="search"
          placeholder="Search..."
          label="Search..."
          forr="search"
          disabled
        // onChange={(e) => {
        //   onSearch(e.target.value);
        // }}
        // inputRef={searchEl}
        />
      </Col>

      <Col span={24}>
        <Col className="chat-contacts px-2">
          <Col className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="chat"
              role="tabpanel"
              aria-labelledby="chat-tab"
            >
              {loading ? (
                <Spinner />
              ) : rooms?.length ? (
                rooms?.map((u, idx) => {
                  return (
                    <Row>
                      {(() => {
                        if (u.type === RoomType[0].id) {
                          return (
                            <Col span={24} className="single-contact"
                              style={{
                                cursor: "pointer",
                                backgroundColor:
                                  u.id === activeRoom ? "rgba(212, 214, 217, 0.6)" : "",
                              }}>
                              <Col span={4} className="user-avatar">
                                <img src={u.coverImage ? u.coverImage : "https://www.gstatic.com/webp/gallery/1.jpg"} style={{ position: "relative", top: "0", left: "0", borderRadius: "50%", height: "55px", width: "55px" }} alt="user img" />
                                <img src={u.profileImage ? u.profileImage : "https://www.gstatic.com/webp/gallery/2.jpg"} style={{ position: "absolute", top: "5px", left: "10px", borderRadius: "50%", height: "55px", width: "55px" }} alt="user img" />
                              </Col>
                              <Col span={17} onClick={() => getMessages(u.id)}>
                                <Col span={24} style={{ fontSize: "12px", fontWeight: "bold", color: "#276598" }}>
                                  {u?.userName}
                                </Col>
                                <Col span={24} style={{ fontSize: "12px", fontWeight: "bold", color: "#3ac1b5" }}>
                                  {u?.tenantName}
                                </Col>
                                <Col span={24} style={{ fontSize: "12px", color: "gray" }}>
                                  {u.lastText ? u.lastText.includes("<style>") ?  "Meeting Invitation" : u.lastText.length ? u.lastText : u.lastText?.substring(0, 60) + "....." : messageResult?.length > 0 ? "file" : ""}
                                </Col>
                              </Col>
                              <Col span={2} style={{ marginTop: "13px" }}>
                                <Badge count={u?.unSeenMessages > 0 ? u?.unSeenMessages : ""} showZero color='#3ac1b5' />
                              </Col>
                              <Col span={1} style={{ marginTop: "15px" }}>
                                {tabs && (
                                  <CanCan
                                    permissionName={Permissions?.CHAT_ARCHIEVE?.name}
                                  >
                                    <span>
                                      <Col>
                                      </Col>
                                      <Col className="profile-dropdown">
                                        <button
                                          type="button"
                                          className="dropdown-toggle moreOption"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <i
                                            className="fa fa-ellipsis-v"
                                            aria-hidden="true"
                                          ></i>
                                        </button>

                                        <ul className="dropdown-menu dropdown-menu-end hf-dropdown-menu">
                                          <li>
                                            <a
                                              href
                                              className="dropdown-item"
                                              onClick={() => updateArchive(true, u)}
                                              type="button"
                                            >
                                              <span className="text">Archive Chat</span>
                                            </a>
                                          </li>
                                        </ul>
                                      </Col>
                                    </span>
                                  </CanCan>
                                )}
                              </Col>
                            </Col>
                          )
                        } else {
                          return (
                            <Col span={24} className="single-contact"
                              style={{
                                cursor: "pointer",
                                backgroundColor:
                                  u.id === activeRoom ? "rgba(212, 214, 217, 0.6)" : "",
                              }}>
                              <Col span={4} className="user-avatar">
                                <img src={u.coverImage ? u.coverImage : "https://www.gstatic.com/webp/gallery/1.jpg"} style={{ position: "relative", top: "0", left: "0", borderRadius: "50%", height: "55px", width: "55px" }} alt="user img" />
                              </Col>
                              <Col span={17} onClick={() => getMessages(u.id)}>
                                <Col span={24} style={{ fontSize: "16px", fontWeight: "bold", color: "#3ac1b5" }}>
                                  {u?.tenantName}
                                </Col>
                                <Col span={24} style={{ fontSize: "12px", color: "gray", fontWeight: `${u.unSeenMessages > 0 ? "bold" : "small"}` }}>
                                {u.lastText ? u.lastText.length ? u.lastText : u.lastText?.substring(0, 60) + "....." : messageResult?.length > 0 ? "file" : ""}
                                </Col>
                              </Col>
                              <Col span={2} style={{ marginTop: "13px" }}>
                                <Badge count={u.unSeenMessages > 0 ? u.unSeenMessages : ""} showZero color='#3ac1b5' />
                              </Col>
                              <Col span={1} style={{ marginTop: "15px" }}>
                                {tabs && (
                                  <CanCan
                                    permissionName={Permissions?.CHAT_ARCHIEVE?.name}
                                  >
                                    <span>
                                      <Col>
                                      </Col>
                                      <Col className="profile-dropdown">
                                        <button
                                          type="button"
                                          className="dropdown-toggle moreOption"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <i
                                            className="fa fa-ellipsis-v"
                                            aria-hidden="true"
                                          ></i>
                                        </button>

                                        <ul className="dropdown-menu dropdown-menu-end hf-dropdown-menu">
                                          <li>
                                            <a
                                              href
                                              className="dropdown-item"
                                              onClick={() => updateArchive(true, u)}
                                              type="button"
                                            >
                                              <span className="text">Archive Chat</span>
                                            </a>
                                          </li>
                                        </ul>
                                      </Col>
                                    </span>
                                  </CanCan>
                                )}
                              </Col>
                            </Col>)
                        }
                      })()}
                    </Row>
                    
                  );
                })
              ) : (
                <Col span={24}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <NoDataFound />
                </Col>
              )}
            </div>
            <div
              className="tab-pane fade show"
              id="archived"
              role="tabpanel"
              aria-labelledby="archived-tab"
            >
              {loading ? (
                <Spinner />
              ) : archiveRooms && archiveRooms.length ? (
                archiveRooms?.map((u, idx) => {
                  return (
                    <Row>
                      {(() => {
                        if (u.type === RoomType[1].id) {
                          return (
                            <Col span={24} className="single-contact"
                              style={{
                                cursor: "pointer",
                                backgroundColor:
                                  u.id === activeRoom ? "rgba(212, 214, 217, 0.6)" : "",
                              }}>
                              <Col span={4} className="user-avatar">
                                <img src={u.coverImage ? u.coverImage : "https://www.gstatic.com/webp/gallery/1.jpg"} style={{ position: "relative", top: "0", left: "0", borderRadius: "50%", height: "55px", width: "55px" }} alt="user img" />
                              </Col>
                              <Col span={19} onClick={() => getMessages(u.id)}>
                                <Col span={24} style={{ fontSize: "12px", fontWeight: "bold", color: "#3ac1b5" }}>
                                  {u?.tenantName}
                                </Col>
                                <Col span={24} style={{ fontSize: "12px", color: "gray" }}>
                                  {u.lastText ? u.lastText : ""}
                                </Col>
                              </Col>
                              <Col span={1} style={{ marginTop: "15px" }}>
                                {tabs && (
                                  <CanCan
                                    permissionName={Permissions?.CHAT_ARCHIEVE?.name}
                                  >
                                    <span>
                                      <Col>
                                      </Col>
                                      <Col className="profile-dropdown">
                                        <button
                                          type="button"
                                          className="dropdown-toggle moreOption"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <i
                                            className="fa fa-ellipsis-v"
                                            aria-hidden="true"
                                          ></i>
                                        </button>

                                        <ul className="dropdown-menu dropdown-menu-end hf-dropdown-menu">
                                          <li>
                                            <a
                                              href
                                              className="dropdown-item"
                                              onClick={() => updateArchive(false, u)}
                                              type="button"
                                            >
                                              <span className="text">Move to Inbox</span>
                                            </a>
                                          </li>
                                        </ul>
                                      </Col>
                                    </span>
                                  </CanCan>
                                )}
                              </Col>
                            </Col>
                          )
                        } else {
                          return (
                            <Col span={24} className="single-contact"
                              style={{
                                cursor: "pointer",
                                backgroundColor:
                                  u.id === activeRoom ? "rgba(212, 214, 217, 0.6)" : "",
                              }}>
                              <Col span={4} className="user-avatar">
                                <img src={u.coverImage ? u.coverImage : "https://www.gstatic.com/webp/gallery/1.jpg"} style={{ position: "relative", top: "0", left: "0", borderRadius: "50%", height: "55px", width: "55px" }} alt="user img" />
                                <img src={u.profileImage ? u.profileImage : "https://www.gstatic.com/webp/gallery/2.jpg"} style={{ position: "absolute", top: "5px", left: "10px", borderRadius: "50%", height: "55px", width: "55px" }} alt="user img" />
                              </Col>
                              <Col span={19} onClick={() => getMessages(u.id)}>
                                <Col span={24} style={{ fontSize: "12px", fontWeight: "bold", color: "#276598" }}>
                                  {u.type === 0 ? "Allocator Member" : "Hedge Fund Member"}
                                </Col>
                                <Col span={24} style={{ fontSize: "12px", fontWeight: "bold", color: "#3ac1b5" }}>
                                  {u?.userName}
                                </Col>
                                <Col span={24} style={{ fontSize: "12px", color: "gray" }}>
                                  {u.lastText ? u.lastText : ""}
                                </Col>
                              </Col>
                              <Col span={1} style={{ marginTop: "15px" }}>
                                {tabs && (
                                  <CanCan
                                    permissionName={Permissions?.CHAT_ARCHIEVE?.name}
                                  >
                                    <span>
                                      <Col>
                                      </Col>
                                      <Col className="profile-dropdown">
                                        <button
                                          type="button"
                                          className="dropdown-toggle moreOption"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <i
                                            className="fa fa-ellipsis-v"
                                            aria-hidden="true"
                                          ></i>
                                        </button>

                                        <ul className="dropdown-menu dropdown-menu-end hf-dropdown-menu">
                                          <li>
                                            <a
                                              href
                                              className="dropdown-item"
                                              onClick={() => updateArchive(false, u)}
                                              type="button"
                                            >
                                              <span className="text">Move to Inbox</span>
                                            </a>
                                          </li>
                                        </ul>
                                      </Col>
                                    </span>
                                  </CanCan>
                                )}
                              </Col>
                            </Col>
                          )
                        }
                      })()}
                    </Row>
                  );
                })
              ) : (
                <Col span={24}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <NoDataFound />
                </Col>
              )}
            </div>
          </Col>
        </Col>
      </Col>
      {tabs && (
        <Col span={24} className="chat-tabs">
          <ul className="nav nav-tabs hf-nav-tabs2" id="myTab" role="tablist" style={{ paddingBottom: "20px" }}>
            <li className="nav-item position-relative" role="presentation">
              <Tabs
                tabType="primary"
                controls="chat"
                ariaSelected="true"
                target="#chat"
                tabName="Inbox"
                id="chat-tab"
                onClick={() => {
                  onClickChatTab(companyType);
                  setArchiveMode(false);
                }}
              />
            </li>
            <li className="nav-item position-relative" role="presentation">
              <Tabs
                controls="archived"
                ariaSelected="false"
                target="#archived"
                tabName="Archived"
                id="archived-tab"
                onClick={() => {
                  onClickChatTab(companyType);
                  setArchiveMode(true);
                }}
              />
            </li>
          </ul>
        </Col>
      )}
    </Row>
  );
};

export default ChatSidebar;
